import axios from 'axios'
import Cookies from 'js-cookie'
import * as types from '../mutation-types'

// state
export const state = {
  user: null,
  token: Cookies.get('token')
}

// getters
export const getters = {
  user: state => state.user,
  token: state => state.token,
  check: state => state.user !== null
}

// actions
export const actions = {

  setConfigUser({ commit, state }, {config}){
      let user = state.user
      user.config = config
      commit(types.FETCH_USER_SUCCESS, { user: user })
  },

  saveToken ({ commit, dispatch }, payload) {
    commit(types.SAVE_TOKEN, payload)
  },

  //carregar usuário
  async fetchUser ({ dispatch, commit }) {
      let config = null
      try {
          const { data } = await axios.get('/api/user')
          // configuração pessoal do usuário no sistema
          config = data.config
          commit(types.FETCH_USER_SUCCESS, { user: data })
      } catch (e) {
        commit(types.FETCH_USER_FAILURE)
      }
  },

  //carregar usuário e configura da conta -------------------------------
  async fetchLoginUser ({ store, dispatch, commit }) {
      let config = null
      let venc_plano = null
      let versao_app = null
      try {
          const { data } = await axios.get('/api/user')
          config = data.config
          venc_plano = data.venc_plano          
          commit(types.FETCH_USER_SUCCESS, { user: data })
      } catch (e) {
        commit(types.FETCH_USER_FAILURE)
      }
      // USER PAGO
      //verificar se o usuário esta bloqueado
      if (venc_plano) {
          // Hoje
          let dataAtual = moment();
          //30 dias de tolerancia após do vencimento
          let dataBloqueio = moment(venc_plano).add(30, 'days')
          if (dataAtual < dataBloqueio) {
              //setar configuração do usuário pago
              if (config) {
                dispatch('config/loadConfigUser',  null , {root: true})
              }else {
                dispatch('config/clearConfigUser',  null , {root: true})
              }
          }
      // USER GRÁTIS
      }else {
          //setar configuração do usuário grátis
          if (config) {
            dispatch('config/loadConfigUser',  null , {root: true})
          }else {
            dispatch('config/clearConfigUser',  null , {root: true})
          }
      }
  },
  // ----------------------------------------------------------------------

  // atualizar user
  saveUser({ commit }, payload){
      commit(types.UPDATE_USER, payload)
  },

  // atualizar usuario
  updateUser ({ dispatch, commit }, payload) {
    // console.log(payload);

    dispatch('fetchUser')

    commit(types.UPDATE_USER, payload)

  },

  async logout ({ commit }) {
    try {
      await axios.post('/api/logout')
    } catch (e) { }

    commit(types.LOGOUT)
  },

  async fetchOauthUrl (ctx, { provider }) {
    const { data } = await axios.post(`/api/oauth/${provider}`)

    return data.url
  }
}

// mutations
export const mutations = {

  [types.SAVE_TOKEN] (state, { token, remember }) {
    state.token = token
    Cookies.set('token', token, { expires: remember ? 365 : null })
  },

  [types.FETCH_USER_SUCCESS] (state, { user }) {
    state.user = user
  },

  [types.FETCH_USER_FAILURE] (state) {
    state.token = null
    Cookies.remove('token')
  },

  [types.LOGOUT] (state) {
    state.user = null
    state.token = null

    Cookies.remove('token')
  },

  [types.UPDATE_USER] (state, { user }) {
    state.user = user
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/auth.js